module.exports = __webpack_public_path__ + "media/images/facebook-icon-679e38c212cf4758527e28330cc6dd15.svg";